import {
  useCollectionStoreOptions,
  useCollectionStoreProps
} from "./6DS7ZDWX.js";
import {
  useStore,
  useStoreProps
} from "./FHQZ2KRN.js";
import {
  __spreadValues
} from "./PNRLI7OV.js";

// src/composite/composite-store.ts
import * as Core from "@ariakit/core/composite/composite-store";
function useCompositeStoreOptions(props) {
  return useCollectionStoreOptions(props);
}
function useCompositeStoreProps(store, props) {
  store = useCollectionStoreProps(store, props);
  useStoreProps(store, props, "activeId", "setActiveId");
  useStoreProps(store, props, "includesBaseElement");
  useStoreProps(store, props, "virtualFocus");
  useStoreProps(store, props, "orientation");
  useStoreProps(store, props, "rtl");
  useStoreProps(store, props, "focusLoop");
  useStoreProps(store, props, "focusWrap");
  useStoreProps(store, props, "focusShift");
  return store;
}
function useCompositeStore(props = {}) {
  const options = useCompositeStoreOptions(props);
  const store = useStore(
    () => Core.createCompositeStore(__spreadValues(__spreadValues({}, props), options))
  );
  return useCompositeStoreProps(store, props);
}

export {
  useCompositeStoreOptions,
  useCompositeStoreProps,
  useCompositeStore
};
